import gql from 'graphql-tag';

export default gql`
  mutation updateLocale($locale: String!) {
    updateLocale(locale: $locale) @client
  }
`;



// WEBPACK FOOTER //
// ./app/containers/LanguageProvider/graphql/updateLocale.gql.js